import { action } from 'typesafe-actions';
import { DownloadAttachmentsTypes } from './types';

export const loadAttachmentsRequest = (protocolo: number, mensagem: number) =>
  action(DownloadAttachmentsTypes.LOAD_DOWNLOADATTACHMENTS_REQUEST, { protocolo, mensagem });

export const loadAttachmentsFailure = () =>
  action(DownloadAttachmentsTypes.LOAD_DOWNLOADATTACHMENTS_FAILURE);
